<template lang="pug">
.current(v-if='current && slides')
  #viewer2(ref="viewer", @click="viewerClick") 
    current-project(
      title="Current", 
      :current="currentSlide", 
      :slides="slides", 
      :transition="transition"
      @imgHover="showTitle(slides[currentSlide].caption, true)",
      @imgLeave="hideTitle")
</template>

<script>
import Vue from 'vue'
import CurrentProject from '@/components/CurrentProject'
import _throttle from 'lodash/throttle'
import VueScrollTo from 'vue-scrollto' // '@/scripts/scrollTo'
// import VueScrollTo from '@/scripts/scrollTo'

export default {
  name: 'Current',
  data () {
    return {
      transition: null,
      currentSlide: 0,
      sliderThrottle: 850, // window.innerWidth > Vue.config.bkpt.mobile ? 950 : 700
    }
  },
  props: ['current'],
  components: {
    CurrentProject
  },
  watch: {
    currentSlide () {
      if (this.slides[this.currentSlide].gray_slide) {
        console.log('GREY SLIDE visible in Current')
        this.$parent.mobileGreySlide = true
        // if the window width is mobile
        if (window.innerWidth > Vue.config.bkpt.mobile) {
          this.hideTitle(this.sliderThrottle + 100)
        }
      } else {
        // not grey slide
        this.$parent.mobileGreySlide = false
      }
    }
  },
  computed: {
    slides () {
      let c = this.current
      if (c && c.data && c.data.slides && c.data.slides.length) {
        return c.data.slides
      }
    }
  },
  methods: {
    nextIndex () {
      return this.current + 1 === this.projects.length ? 0 : this.current + 1
    },
    viewerClick (e) {
      const prev = e.clientX - e.target.offsetLeft < e.target.offsetWidth / 2
      if (prev) return this.previous()
      return this.next()
    },
    next: _throttle(function () {
      this.transition = 'slideleft'
      const lastSlide = this.currentSlide === this.slides.length - 1
      if (lastSlide) {
        // this.current = this.current + 1 > this.projects.length - 1 ? 0 : this.current + 1
        this.currentSlide = 0
        // this.hideTitle()
      } else {
        this.currentSlide++
      }
    }, this.sliderThrottle),
    previous: _throttle(function () {
      this.transition = 'slideright'
      const firstSlide = this.currentSlide - 1 < 0
      if (firstSlide) {
        // this.current = this.current - 1 < 0 ? this.projects.length - 1 : this.current - 1
        this.currentSlide = this.slides.length - 1
      } else {
        this.currentSlide--
        // if (this.currentSlide === 0) this.hideTitle()
      }
    }, this.sliderThrottle),
    // scrollToViewer (duration = 1000) {
    //   this.$nextTick(() => {
    //     if (this.$refs.viewer) return VueScrollTo.scrollTo(this.$refs.viewer, duration)
    //   })
    // },
    hideTitle (delay = 0) {
      // this.titleTmOut = setTimeout(() => { this.titleVisible = false }, delay)
      this.titleTmOut = setTimeout(() => { this.$parent.titleVisible = false }, delay)
    },
    showTitle (prismicText, timeoutOnTouch) {
      // console.log('showTitle', prismicText)
      // this.$emit('showTitle', prismicText)
      // console.log(this.$parent)
      this.$parent.showTitle(prismicText, timeoutOnTouch)

      // if (this.infoInvisible) {
      //   this.title = Vue.$html(prismicText)
      //   this.titleVisible = true
      //   clearTimeout(this.titleTmOut)
      //   // if (timeoutOnTouch) {
      //     // if (Modernizr.touchevents) this.hideTitle(2000)
      //   // }
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../style/variables';
  
  .current {
    padding: 0 0 3rem 0;
    /* background-color: rgb(234, 234, 234) !important; */
    &.projects--animating{
      height:100vh;
      height: calc(var(--vh, 1vh) * 100);
      overflow:hidden;
      .main{
        height:100vh;
        height: calc(var(--vh, 1vh) * 100);
        overflow-y:scroll;
      }
    }

    // change background on scroll
    transition: background-color $trans-bgfade;
    /* background-color:$color-wht; */
    /* &.projects--projectview{
      background-color:$color-wht;
    } */
  }
  
  #viewer2{
    position:relative;
    overflow:hidden; // ffx
    width:100%;
    height:100vh;
    height: calc(var(--vh, 1vh) * 100);
    cursor: url(../assets/icons/cursor-dot.png) 9 9, auto;
    cursor: -webkit-image-set(
      url(../assets/icons/cursor-dot.png) 1x,
      url(../assets/icons/cursor-dot@2x.png) 2x
    ) 9 9, auto;
    > *{
      @include background(absolute);
    }
  }
.debug {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: black;
  color: white;
}
</style>


// WEBPACK FOOTER //
// Current.vue?091ea816